// extracted by mini-css-extract-plugin
export default {"stepCard":"Step_stepCard__JrNgv","stepIcon":"Step_stepIcon__5KSH+","stepTitle":"Step_stepTitle__uYQH9","bold":"Step_bold__qjyD2"};